module.exports = __webpack_public_path__ + "img/2.0e18b2cd.png";